<template>
	<!-- 登录界面，在外套了一层layout下的userLayout -->
	<div class="main">
		<el-tabs v-model="activeName" @tab-click="handleClick" stretch style="margin-bottom:20px">
			<el-tab-pane label="账号密码登录" name="usernameLogin" />
		</el-tabs>
		<el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules">
			<el-form-item prop="username">
				<el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="iconfont iconyonghu1"
					clearable />
			</el-form-item>
			<el-form-item prop="password">
				<el-input type="password" v-model="loginForm.password" placeholder="请输入密码"
					prefix-icon="iconfont iconmima" show-password clearable />
			</el-form-item>
		</el-form>
		<el-button type="primary" size="medium" class="login-button" @click="factoryLogin">工厂登录</el-button>
		<el-button size="medium" class="login-button" @click="platformLogin">平台登录</el-button>
		<!-- <div class="user-login-other">
      <span>其他登录方式</span>
      <a>
        <i class="el-icon-chat-dot-round" />
        <i class="iconfont icon-3702mima" />
      </a>
      <a class="register">忘记密码</a>
    </div> -->
	</div>
</template>

<script>
	import * as api from '@/api/login/index'
	export default {
		data() {
			return {
				loginForm: {
					username: '',
					password: ''
				},
				activeName: 'usernameLogin',
				loginFormRules: {
					//   验证用户名是否合法
					username: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 15,
							message: '长度在3 到 10 个字符之间',
							trigger: 'blur'
						}
					],
					//   验证密码是否合法
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 15,
							message: '长度在6 到 15 个字符之间',
							trigger: 'blur'
						}
					]
				},
				tokenValue: '' //241115 保存单点登录的token
			}
		},
		methods: {
			handleClick() {},
			// 工厂登录
			factoryLogin() {
				this.$refs.loginFormRef.validate(valid => {
					if (valid) {
						const data = this.loginForm
						api.factoryLogin(data).then((res) => {
							res = res.data
							this.$message.success('登录成功')
							// window.sessionStorage.setItem('type', this.$params.pw)// 密码入口登陆
							window.sessionStorage.setItem('factoryNameList', JSON.stringify([res
								.factoryName
							]))
							window.sessionStorage.setItem('userInfo', JSON.stringify({
								username: res.username,
								phone: res.phone
							}))
							window.sessionStorage.setItem('id', res.userId) // 用于绑定手机用的账号id
							window.sessionStorage.setItem('token', 'Bearer ' + res.token)
							window.sessionStorage.setItem('selectFactoryValue', '')
							window.sessionStorage.setItem('factoryId', res.factoryId)
							// window.sessionStorage.setItem('userRole', res.data.userInfo.userRole)
							this.$router.push('/dashboard')
						})

					}
				})
			},
			// 平台登录
			platformLogin() {
				this.$refs.loginFormRef.validate(valid => {
					if (valid) {
						const formatLogin = this._.cloneDeep(this.loginForm)
						formatLogin.username = '-' + formatLogin.username
						const data = formatLogin
						api.platformLogin(data).then((res) => {
							res = res.data
							this.$message.success('登录成功')
							window.sessionStorage.setItem('id', res.userId)
							window.sessionStorage.setItem('userInfo', JSON.stringify({
								username: res.username,
								phone: res.phone
							}))
							window.sessionStorage.setItem('username', res.username)
							window.sessionStorage.setItem('token', 'Bearer ' + res.token)
							window.sessionStorage.setItem('queryFactoryName', '')
							window.sessionStorage.setItem('activePath', 'factories')
							this.$router.push('/platform/home')
						})
					}
				})
			}
		},

		created() {
			// hongmj: 取admin用户选中的工厂名--sta
			// hongmj: 案1: 利用store
			const savedFactoryName = this.$store.state.adminSelectFactory.factory

			// hongmj: 案2 利用sessionStorage--不好使
			// const savedFactoryName = window.sessionStorage.getItem('adminSelectFactoryName')

			// console.log('savedFactoryName=', savedFactoryName)
			// hongmj: 取admin用户选中的工厂名--end

			sessionStorage.clear()
		},

		//241115 hongmj 新增单点登录-sta
		mounted() {
			//在 Vue 组件中，首先获取当前页面的 URL。
			const url = window.location.href;

			//然后，从 URL 中提取出token及其后面的部分。可以使用字符串操作方法，比如split方法来分割 URL 字符串，找到token参数的位置并提取其值。
			const tokenIndex = url.indexOf('token=');
			if (tokenIndex !== -1) {
				const tokenPart = url.substring(tokenIndex + 'token='.length);
				const ampersandIndex = tokenPart.indexOf('&');
				if (ampersandIndex !== -1) { //有多个参数?    token=xxx&name=A
					this.tokenValue = tokenPart.substring(0, ampersandIndex);
				} else { //只有 token?
					this.tokenValue = tokenPart;
				}
			}
			console.log('tokenValue=', this.tokenValue)
			window.sessionStorage.setItem('token', 'Bearer ' + this.tokenValue)

			if ('' != this.tokenValue) { //token非空才执行单点登录
				this.$requestBase({
					url: 'v1/factory/admin/auth',
					method: 'POST',
					
					//hongmj: 不能直接填充headers，要用axious.js中的initRequest()初始化。
					// headers: {
					// 	'Content-Type': 'application/json',
					// 	'Authorization': 'Bearer ' + this.tokenValue,
					// }
				}).then(res => {
					res = res.data
					if (res != undefined) { //返回401时候，res.data=null
						this.$message.success('登录成功')
						// window.sessionStorage.setItem('type', this.$params.pw)// 密码入口登陆
						window.sessionStorage.setItem('factoryNameList', JSON.stringify([res
							.factoryName
						]))
						window.sessionStorage.setItem('userInfo', JSON.stringify({
							username: res.username,
							phone: res.phone
						}))
						window.sessionStorage.setItem('id', res.userId) // 用于绑定手机用的账号id
						window.sessionStorage.setItem('token', 'Bearer ' + res.token)
						window.sessionStorage.setItem('selectFactoryValue', '')
						window.sessionStorage.setItem('factoryId', res.factoryId)
						// window.sessionStorage.setItem('userRole', res.data.userInfo.userRole)
						this.$router.push('/dashboard')
					} else {
						console.log('登录返回异常')
					}

				})
			}
		}
		//241115 hongmj 新增单点登录-end
	}
</script>

<style lang="less" scoped>
	.login-button {
		width: 100%;
		margin-bottom: 16px;
	}

	.el-button+.el-button {
		margin-left: 0px;
	}

	.el-form-item {
		margin-bottom: 24px;
	}
</style>